import type {
	ShadowCreateZoneRequest,
	ShadowUpdateZoneRequest,
	Zone,
} from "@sitescene/types";

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

/**
 * Shadow Realm zones API (org via `X-Shadow-Org` on the client).
 */
export const zonesApi = {
	createZone: async (body: ShadowCreateZoneRequest): Promise<Zone> => {
		const response = await apiClient.post<Zone>(
			ENDPOINTS.shadow.zones.create,
			body,
		);
		return response.data;
	},

	updateZone: async (
		zoneId: string,
		body: ShadowUpdateZoneRequest,
	): Promise<Zone> => {
		const response = await apiClient.patch<Zone>(
			ENDPOINTS.shadow.zones.update(zoneId),
			body,
		);
		return response.data;
	},
};
